import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import DataTableEns from "./DataTableEns"
import GenerationAuto from "./GenerationAuto"
import GenerationAutoSem from "./GenerationAutoSem"
import ParametreAutoSem from "./ParametreAutoSem"

const Generation = props => {
  const [section, setSection] = useState(0)
  const [add, setAdd] = useState(0);
  const [cloture, setCloture] = useState(0);
  const [semestre, setSemestre] = useState([
    { id: 1, label: "Génération automatique de l'emploi du temps", section: 0 },
    { id: 2, label: "Paramétrage de séance", section: 1 },
  ])
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.email
  useEffect(async () => {
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Génération automatique d'emploi du temps")
    );
    setAdd(typeArticleSubMenu.sous_menu[0].add)
  }, [])
  const renderBlock = section => {
    for (let i = 0; i < semestre.length; i++) {
      if (section === 0) {
        return <GenerationAutoSem semestre={semestre[i].id} />
      }else{
        return <ParametreAutoSem semestre={semestre[i].id} />
      }
    }
  }
  const canAccessSection1 = [
    "gerant@cresus.pro",
    "najiba.chkir@flshs.usf.tn",
    "hinda.dhifi@flshs.usf.tn"
  ].includes(user_id);
  const canAccessSection0 = add === 1;
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Emploi Enseignant | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              {semestre
                .filter(element => {
                  // 🔒 section 0 → add doit être = 1
                  if (element.section === 0 && !canAccessSection0) {
                    return false;
                  }

                  // 🔒 section 1 → utilisateurs autorisés uniquement
                  if (element.section === 1 && !canAccessSection1) {
                    return false;
                  }

                  return true;
                })
                .map((element, index) => (
                  <NavItem key={index}>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: section === element.section,
                      })}
                      onClick={() => setSection(element.section)}
                    >
                      <span className="d-none d-sm-block">{element.label}</span>
                    </NavLink>
                  </NavItem>
                ))}
            </Nav>

            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Generation)
